<template>
  <Div class="information">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck v-if="popup == 'check'" :text="successText" :remind="remind" :title="popup_title" @go="popupAction"
          @cancel="poupupEnter"></PopupCheck>
        <PopupText v-if="popup == 'text'" :remind="remind" :title="popup_title" :text="successText"
          @check="poupupEnter">
          <Div class="notice_file_dow flex">
            <div v-for="(item, index) in popup_fileList" :key="index">
              <a :href="`${storage}${item.file}`" target="_blank">
                <button class="btn_border_black">{{ item.file.split("/")[1] }}</button>
              </a>
            </div>
          </Div>
        </PopupText>
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>

    <!-- <div class="login_information pink">
      <h1>Hello, Have a Good Day!</h1>
      <div class="block">
        <h2>證件逾期通知</h2>
        <div class="block_list">
          <div class="no_data">
            <i class="el-icon-warning-outline"></i>
            <p>NO Data</p>
          </div>
        </div>
      </div>
    </div>-->

    <div class="flex">
      <div class="login_information white">
        <H2>最新公告</H2>
        <!-- 置頂 -->
        <div class="is_sticky">
          <template v-for="(item, index) in notice_list">
            <div class="notice_list flex" v-if="item.is_sticky" :key="index" @click="noticeDetialed(item, index)">
              <div class="notice_item">{{ item.title }}</div>
              <div class="notice_time">{{ item.start_date }}</div>
            </div>
          </template>
        </div>
        <!-- 一般 -->
        <template v-for="(item, index) in notice_list">
          <div class="notice_list flex" v-if="!item.is_sticky && index < 7" :key="index"
            @click="noticeDetialed(item, index)">
            <div class="notice_item">{{ item.title }}</div>
            <div class="notice_time">{{ item.start_date }}</div>
          </div>
        </template>
        <!--更多-->
        <div class="notice_more flex">
          <button class="btn_gray" @click="noticeMore">More</button>
        </div>
      </div>
    </div>
    <div class="login_information white">
      <H2>課程</H2>
      <template v-for="(item, index) in course_list">
        <div class="course_list flex" :key="index" @click="chooseCourse(item)">
          <!-- v-if="index==(course_list.length-1)" -->
          <div class="notice_item">{{ item.course_name }}</div>
        </div>
      </template>
    </div>
  </Div>
</template>
<style lang="scss">
.information {
  width: 100%;
}

.pink {
  background: #f3adad;

  h1 {
    color: #fff;
  }
}

.white {
  background: #fff;

  h1 {
    color: var(--mainColorHover);
  }
}

.login_information {
  margin: 0px 10px 30px 10px;
  text-align: left;
  width: 100%;
  padding: 30px;
  border-radius: 8px;

  h1 {
    font-size: 25px;

    font-weight: bold;
  }

  h2 {
    font-weight: bold;
    margin-bottom: 15px;
  }

  .is_sticky {
    background: #e8e9f1;
    padding: 0 10px;

    // .notice_list {}
  }

  .notice_list {
    cursor: pointer;
    border-bottom: 1px solid #e4e4e4;
    margin: 5px 0;
    padding: 10px 0;
    justify-content: space-between;

    &:hover {
      color: var(--mainColor);
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .course_list {
    cursor: pointer;
    border-bottom: 1px solid #e4e4e4;
    margin: 5px 0;
    padding: 10px 0;
    justify-content: space-between;

    &:last-child {
      border-bottom: none;
    }
  }

  .notice_more {
    justify-content: flex-end;

    .btn_gray {
      width: 80px;
      font-size: 12px;
    }
  }

  .block {
    padding-top: 10px;
    margin-top: 10px;
    color: #fff;
    border-top: 1px dashed #fff;
    font-size: 15px;

    h2 {
      padding: 5px 20px;
      background: #fff;
      width: fit-content;
      color: #fa9090;
    }
  }
}

.information_block {
  display: flex;
}

.notice_file_dow {
  flex-wrap: wrap;

  button {
    margin: 5px;
    padding: 3px 8px;
    border-radius: 3px;
    font-size: 12px;
    width: fit-content;
  }
}
</style>
<script>
export default {
  name: "information",
  data() {
    return {
      notice_list: [],
      popupStatus: false,
      successText: null,
      popup: null,
      popup_title: null,
      popup_fileList: [],
      course_list: [],
      dowFile: [],
      data: [],
      file: {},
      popup: '',
      popupStatus: false,
      successText: '',
      popup_title: '',
      dowFile: [],
      files_name: [
        { key: 'safe_file', file_name: "承攬商資安管制聲明書" },
        { key: 'information_file', file_name: "承攬商安全衛生環保承諾書" },
      ],
      missing_files: [],
      remind: false,
    };
  },
  computed: {
    storage() {
      return this.$http.base.storage;
    }
  },
  created() {
    this.getNotice();
    this.getCourse();
    this.getVendorData();
  },
  methods: {
    getNotice() {
      this.$http.api.admin.announcementGet().then(res => {
        this.notice_list = res.data;
      });
    },
    noticeDetialed(item, index) {
      this.$http.api.admin.announcementGet(item.announcement_id).then(res => {
        this.popupStatus = true;
        this.popup = "check";
        this.popup_title = res.data[0].title;
        this.successText = `
          ${res.data[0].content}
        `;
        this.popup_fileList = res.data[0].attachment;
      });
    },
    poupupEnter() {
      this.popupStatus = false;
    },
    noticeMore() {
      this.$router.push({
        name: "notice"
      });
    },
    getCourse() {
      this.$http.api.admin.course().then(res => {
        this.course_list = res.data
      })
    },
    chooseCourse(item) {
      const num = Math.floor(Math.random() * 10)
      window.open(`${this.storage}${item.course_path}?v=${num}`, "_blank")
    },
    async getVendorData() {
      //承攬商id必須由登入拿到
      await this.$http.api.vendor
        .vendorBasisGet(this.$store.state.user.id)
        .then((res) => {
          this.data = res.data;
          Object.keys(res.data).forEach((el) => {
            if (el.includes('_file')) {
              this.$set(this.file, el, res.data[el])
            }
          })
        });
      this.getDowFile();
      this.check_vendorFiles();
    },
    getDowFile() {
      this.$http.api.file.registerDow().then((res) => {
        //  this.dowFile=res.data.filter(el=>{
        //   return !el.file_name.includes('教學')
        // })
        this.dowFile = res.data;
      });
    },
    check_vendorFiles() {
      if (this.data.factory_address) {
        this.files_name.push({ key: 'factory_file', file_name: "工廠登記證" });
      }
      for (let item in this.file) {
        if (this.file[item] === null) {
          if (item !== 'business_file') {
            const miss_item = this.files_name.find(el => el.key === item);
            if (miss_item) {
              this.missing_files.push(miss_item.file_name);
            }


          }
        }
      }
    },
    popupAction(val) {
      if (val) {
        this.$router.push('/contractor/registered');
      }
    },
    poupupEnter() {
      this.popupStatus = false;
    }
  },
  watch: {
    missing_files: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.popupStatus = true;
          this.popup = "check";
          this.remind = true;
          this.popup_title = `請記得上傳相關檔案`;
          this.successText = newVal.join(", ");
        }
      }
    }
  }
}
</script>